import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ArrayResponse} from '../models/array-response';
import {Office} from '../models/culture';
import {SendBackResult} from '../models/send-back-result';
import {AppSettingsService} from './app-settings.service';
import {BaseRestService} from './base-rest.service';
import {SharedModule} from '../shared.module';

@Injectable({providedIn: SharedModule})
export class ClientConfigurationService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'ClientConfigurationService'; }

  protected get isAnonymous(): boolean { return false; }

  // tslint:disable-next-line:no-any
  getList(clientId: string): Observable<SendBackResult<ArrayResponse<any>>> {
    // console.log('LoadClientConfigurationAction')
    // tslint:disable-next-line:no-any
    return this.get<ArrayResponse<any>>(`/client/${clientId}/Configurations`);
  }
}
